module.exports = __webpack_public_path__ + "static/media/login.b9116a7b.jpg";